//index.js
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { AtendimentoProvider } from "./hooks/useAtendimentoAtual";

import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./auth/AuthContext"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
    <BrowserRouter>
        <AuthProvider>
            <AtendimentoProvider>
                <App />
            </AtendimentoProvider>
        </AuthProvider>
    </BrowserRouter>
)